import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { QueueLayoutAbstraction } from "@shared-core/general/queue/abstractions/queue-layout.abstraction";

@Component({
  selector: "app-queue-footer",
  standalone: true,
  templateUrl: "./queue-footer.component.html",
  styleUrl: "./queue-footer.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QueueFooterComponent {
  private readonly queueLayout = inject(QueueLayoutAbstraction);
  readonly location = this.queueLayout.location;
}
